'use client'
import { useEffect, useState } from "react"
import { AppText } from "../AppText"
import { styles, SharedLinksVariant } from "./SharedLinks.css"
import clsx from "clsx"
import { LinkedinIcon } from "@otomoro/components/icons/Linkedin"
import { XIcon } from "@otomoro/components/icons/X"
import { FacebookIcon } from "@otomoro/components/icons/Facebook"
import { WhatsappIcon } from "@otomoro/components/icons/Whatsapp"
import { ClipboardIcon } from "@otomoro/components/icons/Clipboard"

interface SharedLinksProps extends SharedLinksVariant{
  className?: string
}

export const SharedLinks: React.FC<SharedLinksProps> = ({className}) => {
  const { base, list, item, link } = styles()
  const [url, setUrl] = useState('')

  useEffect(() => {
    if (typeof window === 'undefined') return

    setUrl(window.location.href)
  }, [url])

  const handleClick = () => {
    navigator.clipboard.writeText(url)
  }

  return (
    <aside className={clsx(base(), className)}>
      <AppText as="strong" size="base">Share this article</AppText>
      <ul className={list()}>
        <li className={item()}>
          <a href={`https://x.com/intent/tweet?url=${url}`} target="_blank" rel="noreferrer" className={link()}>
            <XIcon />
          </a>
        </li>
        <li className={item()}>
          <a href={`https://www.facebook.com/sharer.php?u=${url}`} target="_blank" rel="noreferrer" className={link()}>
            <FacebookIcon />
          </a>
        </li>
        <li className={item()}>
          <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`} target="_blank" rel="noreferrer" className={link()}>
            <LinkedinIcon />
          </a>
        </li>
        <li className={item()}>
          <a href={`whatsapp://send?text=Check out this page: ${url}`} target="_blank" rel="noreferrer" className={link()}>
            <WhatsappIcon />
          </a>
        </li>
        <li className={item()}>
          <span tabIndex={0} aria-label="Copy on clipboard" onClick={handleClick} className={clsx(link(), 'cursor-pointer')}>
            <ClipboardIcon />
          </span>
        </li>
      </ul>
    </aside>
  )
}